<template>
  <div class="info-overlay" @click="closeInfo">
    <div class="info-container" @click="allowClickIfAnchor">
      <Close @close="closeInfo" />
      <div
        v-if="loaded"
        v-html="html" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Close from './Close'
import { TweenMax, Sine } from 'gsap'

TweenMax.defaultEase = Sine.easeOut

export default {
  name: 'MVMInfo',
  components: {
    Close
  },

  props: {
    msg: String
  },

  data () {
    return {
      loaded: false,
      lastScrollTop: 0,
      scrollDirection: 'down',
      scrollSticky: false,
      $overlay: null,
      $close: null,
      closeBot: 0,
      closeTop: 0,
      closeHeight: 0,
      lastTrUp: 0,
      lastTrDown: 0,
      scrollChangePos: 0,
      topAuto: false,
      html: ''
    }
  },

  mounted () {
    axios
      .get(`/api/page/contact`)
      .then(response => {
        this.html = response.data.page.html
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => {
        this.loaded = true
        this.fadeIn()
      })

    this.$container = document.querySelector('.info-container')
    this.$close = document.querySelector('.close-icon-container')
    this.$overlay = document.querySelector('.info-overlay')
    this.$overlay.addEventListener('scroll', this.onScroll)
    let rect = this.$close.getBoundingClientRect()
    this.closeTop = rect.top
    this.closeBot = rect.bottom
    this.closeHeight = rect.bottom - rect.top
  },

  destroyed () {
    this.$overlay.removeEventListener('scroll', this.onScroll)
    document.documentElement.style.overflowY = 'scroll'
    this.$overlay.style.overflowY = 'hidden'
    document.body.style.paddingRight = 0
  },

  inject: [
    'sbWidth'
  ],

  metaInfo: {
    title: 'MVM',
    titleTemplate: 'INFO // %s'
  },

  methods: {
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },

    hideTagContainer (onCmp) {
      const tagContainer = document.querySelector('.tags-container')
      TweenMax.to(tagContainer, 0.2, {
        opacity: 0,
        onComplete: () => {
          TweenMax.set(tagContainer, {
            zIndex: 0
          })
          onCmp()
        }
      })
    },

    showTagContainer () {
      const tagContainer = document.querySelector('.tags-container')
      TweenMax.set(tagContainer, {
        zIndex: 5
      })
      TweenMax.to(tagContainer, 0.6, {
        opacity: 1
      })
    },

    hexToRgbA (hex, opacity) {
      let c
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + opacity + ')'
      }
      throw new Error('Bad Hex')
    },

    fadeIn () {
      let rgba
      let rgb = this.hexToRgbA('#000000', '1.0')

      if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
        rgba = this.hexToRgbA('#000000', '0.5')
      } else {
        rgba = this.hexToRgbA('#000000', '0.8')
      }

      TweenMax.set(this.$container, {
        y: 5,
        opacity: 0
      })

      TweenMax.set(this.$overlay, {
        opacity: 0,
        overflowY: 'hidden'
      })

      TweenMax.to(this.$overlay, 0.25, {
        backgroundColor: rgb,
        opacity: 1,
        onComplete: () => {
          document.documentElement.style.overflowY = 'hidden'
          document.body.style.paddingRight = `${this.sbWidth}px`
          this.$overlay.style.overflowY = 'auto'

          TweenMax.to(this.$container, 0.25, {
            opacity: 1,
            y: 0,
            onComplete: () => {
              TweenMax.to(this.$overlay, 0.25, {
                backgroundColor: rgba
              })
            }
          })
        }
      })
    },

    closeInfo () {
      let rgba
      // let rgb = this.hexToRgbA('#000000', '1.0')

      if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
        rgba = this.hexToRgbA('#000000', '0.5')
      } else {
        rgba = this.hexToRgbA('#000000', '0.8')
      }

      TweenMax.to(this.$overlay, 0.25, {
        opacity: 1,
        backgroundColor: rgba,
        onComplete: () => {
          document.documentElement.style.overflowY = 'scroll'
          this.$overlay.style.overflowY = 'hidden'
          document.body.style.paddingRight = 0
          TweenMax.to(this.$container, 0.25, {
            opacity: 0,
            y: 5,
            onComplete: () => {
              TweenMax.to(this.$overlay, 0.25, {
                opacity: 0,
                onComplete: () => {
                  this.$router.push({ name: 'home' })
                }
              })
            }
          })
        }
      })
    },

    back () {
      alert('hepp!')
    },

    allowClickIfAnchor (e) {
      if (e.target.nodeName === 'A') {

      } else {
        e.stopPropagation()
        e.preventDefault()
      }
    },

    onScroll (e) {
      let scrollTop = e.target.scrollTop
      this.scrollDirection = (scrollTop < this.lastScrollTop) ? 'up' : 'down'
      this.lastScrollTop = scrollTop

      if (this.scrollDirection === 'up') {
        if (scrollTop > this.closeBot) {
          TweenMax.to(this.$close, 0.3, {
            y: '0',
            onComplete: () => {}
          })
        } else {
          // above the fold
          // TweenMax.set(this.$close, { top: 0, y: 0 })
          // this.topAuto = false
        }
      } else {
        if (scrollTop < this.closeBot) {
          // above the fold
          TweenMax.set(this.$close, { top: 'auto' })
          this.topAuto = true
        } else {
          if (this.topAuto) {
            TweenMax.set(this.$close, { top: 0, y: '-100' })
            this.topAuto = false
          } else {
            TweenMax.to(this.$close, 0.3, {
              y: '-100',
              onComplete: () => {}
            })
          }
        }
      }
    },

    toggleScrollSticky (val) {
      this.scrollSticky = val
      if (val === true) {
        this.$close.style.position = 'sticky'
        this.$close.style.transform = 'translateY(-100%)'
      } else {
        this.$close.style.position = 'static'
        this.$close.style.transform = 'translateY(0)'
      }
    }
  }
}
</script>
